import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Grid } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useTranslation } from 'react-i18next';
import { PaddedContainer } from '../../ui-kit';
import { CustomPaymentMethodList } from '../../modules';
import { routePaths } from '../../routePaths';
import { ProtectedAction } from '../../ui-kit/ProtectedAction';
import { BackofficePermission } from '../../generated/graphql';

const CustomPaymentMethods = () => {
    const { t } = useTranslation();
    return (
        <PaddedContainer padding={4}>
            <Grid item xs={12}>
                <Box mb={4} display="flex" justifyContent="flex-end">
                    <ProtectedAction
                        permissions={{ backoffice: [BackofficePermission.CanAddPaymentMethods] }}
                        component={({ disabled }) => (
                            <Button
                                startIcon={<AddIcon />}
                                disabled={disabled}
                                component={RouterLink}
                                to={routePaths.customPaymentMethodsSettingsCreate}
                                variant="contained"
                                color="primary"
                            >
                                {t('New payment method')}
                            </Button>
                        )}
                    />
                </Box>
            </Grid>
            <Grid item xs={12}>
                <CustomPaymentMethodList />
            </Grid>
        </PaddedContainer>
    );
};

export default CustomPaymentMethods;